// @ts-nocheck
import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementWebformSection'],
  (item, ctx) => {
    return {
      $el: 'div',
      attrs: {
        class: 'formkit-section',
      },
      children: [
        {
          $el: item.element.titleTag || 'div',
          attrs: {
            class: 'formkit-section-title',
          },
          children: item.title,
        },
        ...ctx.buildChildren(item.element.items),
      ],
    }
  },
)
